/* @flow */
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';
import OrganizationProfile from 'entities/OrganizationProfile';

class OrganizationProfiles extends Collection {
  initialize() {
    this.model = OrganizationProfile;
  }

  static search(queryType, query, page, perPage) {
    const options = {
      query,
      page: (page || 1),
      per_page: (perPage || 20),
    };

    return apiRequest('/organization_profiles', 'GET', options).then(
      response => OrganizationProfiles.fromJSON(response)
    );
  }
}

export default OrganizationProfiles;



// WEBPACK FOOTER //
// ./src/collections/OrganizationProfiles.js